import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { JobServiceApi } from "../../services";
import * as jobConstants from "../../enums/jobs";
const initialState = {
  userId: 1,
  clientId: 1,
  totalRecords: 0,
  page: 1,
  size: jobConstants.ROWS_PER_PAGE,
  basicFirst: 0,
  basicRows: jobConstants.ROWS_PER_PAGE,
  watchListTotalRecords: 0,
  watchListPage: 1,
  watchListSize: jobConstants.ROWS_PER_PAGE,
  watchListFirst: 0,
  watchListRows: jobConstants.ROWS_PER_PAGE,
  errorListTotalRecords: 0,
  errorListPage: 1,
  errorListSize: jobConstants.ROWS_PER_PAGE,
  errorListFirst: 0,
  errorListRows: jobConstants.ROWS_PER_PAGE,
  favouriteListTotalRecords: 0,
  favouriteListPage: 1,
  favouriteListSize: jobConstants.ROWS_PER_PAGE,
  favouriteListFirst: 0,
  favouriteListRows: jobConstants.ROWS_PER_PAGE,
  loading: false,
  jobListExist: false,
  parentJobList: [],
  childJobList: [],
  error: '',
  currentTab: jobConstants.TABS.LIVE,
  currentLanguage: 'EN',
  appLanguage:{},
  breadCum: jobConstants.MAINTABLEBEL.LIVE,
  jobDetails: {},
  currentTabJobNo: "",
  jobDeliveryChannelId: "",
  expandedRows: {},
  checkedView: true,
  selectedChannel: { deliveryChannelId: '', deliveryChannel: '' },
  jobRecordsWidgit: {},
  defaultFilterStatus: false,
  fromDate: '',
  toDate: '',
  watchList: [],
  channelFilterList: [],
  deliveryChannelFilterList: [],
}

// For get all delivery channel from SP
export const fetchChannelFilter = createAsyncThunk('jobs/fetchChannelFilter', async (req) => {
  return JobServiceApi.getChannelFilterList(req).then(response => {
    // console.log("thunk res", response?.data)
    return response?.data;
  });
});

// For get all live/current date jobs form SP
export const fetchJobs = createAsyncThunk('jobs/fetchJobs', async (req) => {
  try {
    const parentJobListResponse = await JobServiceApi.getParentJobList(req);
    // console.log("thunk res parent jobs array", parentJobListResponse?.data?.data?.list);

    // For get all user watchlist jobIds from local DB
    const userWatchListResponse = await JobServiceApi.getUserWatchList(req);
    // console.log("thunk res user watch list array", userWatchListResponse?.data?.data);

    const jobDataArr = parentJobListResponse?.data?.data?.list;
    const watchListDataArr = userWatchListResponse?.data?.data;
    let finalDataArr = [];
    jobDataArr?.map(function (x) {
      const result = watchListDataArr.filter(dataArr => dataArr.jobNo == x.jobNo);
      if (result.length > 0) { x.isWatchList = true; }
      finalDataArr.push(x);
    });
    const jobValues = userWatchListResponse?.data?.data.map(obj => obj.jobNo);

    return {
      finalJobListArr: finalDataArr,
      parentJobListArr: parentJobListResponse?.data,
      watchListJobNo: jobValues
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error; // Re-throw the error to be caught by the Redux thunk middleware
  }
});

// For get all watchlist jobs form SP
export const fetchWatchListJobs = createAsyncThunk('jobs/fetchWatchListJobs', async (req) => {
  try {
    const parentJobListResponse = await JobServiceApi.getParentWatchJobList(req);
    // console.log("thunk res parent jobs array", parentJobListResponse?.data?.data?.list);

    // For get all user watchlist jobIds from local DB
    const userWatchListResponse = await JobServiceApi.getUserWatchList(req);
    // console.log("thunk res user watch list array", userWatchListResponse?.data?.data);

    const jobDataArr = parentJobListResponse?.data?.data?.list;
    const watchListDataArr = userWatchListResponse?.data?.data;
    let finalDataArr = [];
    jobDataArr?.map(function (x) {
      const result = watchListDataArr.filter(dataArr => dataArr.jobNo == x.jobNo);
      if (result.length > 0) { x.isWatchList = true; }
      if (x.isWatchList) {
        finalDataArr.push(x);
      }
    });
    const jobValues = userWatchListResponse?.data?.data.map(obj => obj.jobNo);
    return {
      finalJobListArr: finalDataArr,
      parentJobListArr: parentJobListResponse?.data,
      watchListJobNo: jobValues
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error; // Re-throw the error to be caught by the Redux thunk middleware
  }
});

// For get all favourite jobs form SP
export const fetchFavouriteFilterJobs = createAsyncThunk('jobs/fetchFavouriteFilterJobs', async (req) => {
  try {
    const parentJobListResponse = await JobServiceApi.getParentFavouriteJobList(req);
    // console.log("thunk res parent jobs array", parentJobListResponse?.data?.data?.list);

    // For get all user watchlist jobIds from local DB
    const userWatchListResponse = await JobServiceApi.getUserWatchList(req);
    // console.log("thunk res user watch list array", userWatchListResponse?.data?.data);

    const jobDataArr = parentJobListResponse?.data?.data?.list;
    const watchListDataArr = userWatchListResponse?.data?.data;
    let finalDataArr = [];
    jobDataArr?.map(function (x) {
      const result = watchListDataArr.filter(dataArr => dataArr.jobNo == x.jobNo);
      if (result.length > 0) { x.isWatchList = true; }
      finalDataArr.push(x);
    });
    const jobValues = userWatchListResponse?.data?.data.map(obj => obj.jobNo);

    return {
      finalJobListArr: finalDataArr,
      parentJobListArr: parentJobListResponse?.data,
      watchListJobNo: jobValues
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error; // Re-throw the error to be caught by the Redux thunk middleware
  }
});

// For get all error jobs form SP
export const fetchErrorListJobs = createAsyncThunk('jobs/fetchErrorListJobs', async (req) => {
  try {
    const parentJobListResponse = await JobServiceApi.getParentErrorJobList(req);
    // console.log("thunk res parent jobs array", parentJobListResponse?.data?.data?.list);

    // For get all user watchlist jobIds from local DB
    const userWatchListResponse = await JobServiceApi.getUserWatchList(req);
    // console.log("thunk res user watch list array", userWatchListResponse?.data?.data);

    const jobDataArr = parentJobListResponse?.data?.data?.list;
    const watchListDataArr = userWatchListResponse?.data?.data;
    let finalDataArr = [];
    jobDataArr?.map(function (x) {
      const result = watchListDataArr.filter(dataArr => dataArr.jobNo == x.jobNo);
      if (result.length > 0) { x.isWatchList = true; }
      finalDataArr.push(x);
    });
    const jobValues = userWatchListResponse?.data?.data.map(obj => obj.jobNo);

    return {
      finalJobListArr: finalDataArr,
      parentJobListArr: parentJobListResponse?.data,
      watchListJobNo: jobValues
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error; // Re-throw the error to be caught by the Redux thunk middleware
  }
});

// Fetch jobs Records for header wedgit
export const fetchJobsRecordsWedgit = createAsyncThunk('jobs/fetchJobsRecordsWedgit', (req) => {
  return JobServiceApi.getJobsRecordsWedgit(req).then(response => {
    // console.log("thunk res getJobsRecordsWedgit", response?.data)
    return response?.data;
  });
});

// fetch all child jobs of parent job from SP
export const fetchChildJobs = createAsyncThunk('jobs/fetchChildJobs', (req) => {
  return JobServiceApi.getChildJobsByParentId(req).then(response => {
    // console.log("thunk res getChildJobsByParentId", response?.data)
    return response?.data;
  });
});


// fetch parent/child job dtails from SP
export const fetchJobDetails = createAsyncThunk('jobs/fetchJobDetails', (req) => {
  return JobServiceApi.getJobDetails(req).then(response => {
    // console.log("thunk res getJobDetails", response?.data)
    return { data: response.data.data, currentJobNo: req.jobIdentifier };
  });
});

// To add job as user watchlist in local DB
export const addJobsInWatchList = createAsyncThunk('jobs/addJobsInWatchList', (req) => {
  return JobServiceApi.addJobsInWatchList(req).then(response => {
    // console.log("thunk res getChildJobsByParentId", response?.data)
    return response?.data;
  });
});

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = 1;
    },
    setClientId: (state, action) => {
      state.clientId = 1;
    },
    setTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setDefaultLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    setAppLanguage: (state, action) => {
      state.appLanguage = action.payload;
    },
    setBreadCum: (state, action) => {
      state.breadCum = action.payload;
    },
    setJobListExist: (state, action) => {
      state.jobListExist = action.payload;
    },
    filterJobsByChannel: (state, action) => {
      state.parentJobList = action.payload;
      state.totalRecords = action.payload.length;
    },
    setCurrentTabJobNo: (state, action) => {
      state.currentTabJobNo = action.payload;
    },
    setJobDeliveryChannelId: (state, action) => {
      state.jobDeliveryChannelId = action.payload;
    },
    setExpandedRows: (state, action) => {
      state.expandedRows = action.payload;
    },
    setCheckedView: (state, action) => {
      state.checkedView = action.payload;
    },
    setSelectedChannel: (state, action) => {
      state.selectedChannel = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setDefaultFilterStatus: (state, action) => {
      state.defaultFilterStatus = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSize: (state, action) => {
      state.size = action.payload;
    },
    setBasicFirst: (state, action) => {
      state.basicFirst = action.payload;
    },
    setBasicRows: (state, action) => {
      state.basicRows = action.payload;
    },
    setWatchListPage: (state, action) => {
      state.watchListPage = action.payload;
    },
    setWatchListSize: (state, action) => {
      state.watchListSize = action.payload;
    },
    setWatchListFirst: (state, action) => {
      state.watchListFirst = action.payload;
    },
    setWatchListRows: (state, action) => {
      state.watchListRows = action.payload;
    },
    setErrorListPage: (state, action) => {
      state.errorListPage = action.payload;
    },
    setErrorListSize: (state, action) => {
      state.errorListSize = action.payload;
    },
    setErrorListFirst: (state, action) => {
      state.errorListFirst = action.payload;
    },
    setErrorListRows: (state, action) => {
      state.errorListRows = action.payload;
    },
    setFavouriteListPage: (state, action) => {
      state.favouriteListPage = action.payload;
    },
    setFavouriteListSize: (state, action) => {
      state.favouriteListSize = action.payload;
    },
    setFavouriteListFirst: (state, action) => {
      state.favouriteListFirst = action.payload;
    },
    setFavouriteListRows: (state, action) => {
      state.favouriteListRows = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchJobs.fulfilled, (state, action) => {
      // console.log("redux res", action.payload);
      if (action?.payload?.parentJobListArr?.error) {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = [];
        state.totalRecords = 0;
        state.error = '';
      } else {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = action?.payload?.finalJobListArr;
        state.totalRecords = action?.payload?.parentJobListArr?.data?.totalItems;
        state.error = '';
      }
    });

    builder.addCase(fetchJobs.rejected, (state, action) => {
      state.loading = false;
      state.parentJobList = [];
      state.totalRecords = 0;
      state.error = action.error.message;
    });

    builder.addCase(fetchWatchListJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchWatchListJobs.fulfilled, (state, action) => {
      // console.log("redux res", action.payload);
      if (action?.payload?.parentJobListArr?.error) {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = [];
        state.watchListTotalRecords = 0;
        state.error = '';
      } else {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = action?.payload?.finalJobListArr;
        state.watchListTotalRecords = action?.payload?.parentJobListArr?.data?.totalItems;
        state.error = '';
      }
    });

    builder.addCase(fetchWatchListJobs.rejected, (state, action) => {
      state.loading = false;
      state.parentJobList = [];
      state.watchListTotalRecords = 0;
      state.error = action.error.message;
    });


    builder.addCase(fetchFavouriteFilterJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchFavouriteFilterJobs.fulfilled, (state, action) => {
      // console.log("redux res", action.payload);
      if (action?.payload?.parentJobListArr?.error) {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = [];
        state.favouriteListTotalRecords = 0;
        state.error = '';
      } else {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = action?.payload?.finalJobListArr;
        state.favouriteListTotalRecords = action?.payload?.parentJobListArr?.data?.totalItems;
        state.error = '';
      }
    });

    builder.addCase(fetchFavouriteFilterJobs.rejected, (state, action) => {
      state.loading = false;
      state.parentJobList = [];
      state.favouriteListTotalRecords = 0;
      state.error = action.error.message;
    });


    builder.addCase(fetchErrorListJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchErrorListJobs.fulfilled, (state, action) => {
      // console.log("redux res", action.payload);
      if (action?.payload?.parentJobListArr?.error) {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = [];
        state.errorListTotalRecords = 0;
        state.error = '';
      } else {
        state.loading = false;
        state.watchList = action?.payload?.watchListJobNo;
        state.parentJobList = action?.payload?.finalJobListArr;
        state.errorListTotalRecords = action?.payload?.parentJobListArr?.data?.totalItems;
        state.error = '';
      }
    });

    builder.addCase(fetchErrorListJobs.rejected, (state, action) => {
      state.loading = false;
      state.parentJobList = [];
      state.errorListTotalRecords = 0;
      state.error = action.error.message;
    });

    // For Jobs records Wedgit
    builder.addCase(fetchJobsRecordsWedgit.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchJobsRecordsWedgit.fulfilled, (state, action) => {
      // console.log("redux res fetchJobsRecordsWedgit", action.payload);
      state.loading = false;
      state.jobRecordsWidgit = action.payload.data;
      state.error = '';
    });

    builder.addCase(fetchJobsRecordsWedgit.rejected, (state, action) => {
      state.loading = false;
      state.jobRecordsWidgit = {};
      state.error = action.error.message;
    });


    builder.addCase(fetchChildJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchChildJobs.fulfilled, (state, action) => {
      // console.log("redux res fetchChildJobs", action.payload);
      if (action?.payload?.error) {
        state.loading = false;
        state.childJobList = [];
        state.error = '';
      } else {
        state.loading = false;
        state.childJobList = action.payload.data.list;
        state.error = '';
      }
    });

    builder.addCase(fetchChildJobs.rejected, (state, action) => {
      state.loading = false;
      state.childJobList = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchJobDetails.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchJobDetails.fulfilled, (state, action) => {
      // console.log("redux res fetchJobDetails", action.payload);
      state.loading = false;
      const { data, currentJobNo } = action.payload;
      if (data) {
        data.executionWindow = data?.executionWindow[0];
        data.metaWindow = data?.metaWindow[0];
        state.jobDetails[currentJobNo] = data;
      }
      state.error = '';
    });

    builder.addCase(fetchJobDetails.rejected, (state, action) => {
      state.loading = false;
      state.jobDetails = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchChannelFilter.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchChannelFilter.fulfilled, (state, action) => {
      // console.log("redux res fetchChannelFilter", action.payload);
      state.loading = false;
      state.channelFilterList = action?.payload?.data?.list;
      let updatedChannel = action?.payload?.data?.list;
      updatedChannel?.unshift({ deliveryChannelId: '', deliveryChannel: 'Select Channel' });
      state.deliveryChannelFilterList = updatedChannel;
      state.error = '';
    });

    builder.addCase(fetchChannelFilter.rejected, (state, action) => {
      state.loading = false;
      state.channelFilterList = [];
      state.deliveryChannelFilterList = [];
      state.error = action.error.message;
    });

  }
})

export default jobSlice.reducer;
export const {
  setUserId,
  setClientId,
  setTab,
  setDefaultLanguage,
  setAppLanguage,
  setBreadCum,
  setJobListExist,
  filterJobsByChannel,
  setCurrentTabJobNo,
  setJobDeliveryChannelId,
  setExpandedRows,
  setCheckedView,
  setSelectedChannel,
  setFromDate,
  setToDate,
  setDefaultFilterStatus,
  setPage,
  setSize,
  setBasicFirst,
  setBasicRows,
  setWatchListPage,
  setWatchListSize,
  setWatchListFirst,
  setWatchListRows,
  setErrorListPage,
  setErrorListSize,
  setErrorListFirst,
  setErrorListRows,
  setFavouriteListPage,
  setFavouriteListSize,
  setFavouriteListFirst,
  setFavouriteListRows,
} = jobSlice.actions;